<template>
  <div class="container-fluid px-5" id="form">
    <div class="row">
      <div class="col-md-12">
        <h3 class="mb-4">Нарушение</h3>
        <div class="text-white pb-3 border-bottom border-dark" v-if="Object.keys(stream).length > 0">
          <b>{{ stream.org.TYPE_OBJECT }}
            <template v-if="stream.org.CODE_PPE_EGE">{{ stream.org.CODE_PPE_EGE }} <small class="badge badge-pill badge-primary">ЕГЭ</small></template>
            <template v-if="stream.org.CODE_PPE_OGE"> {{ stream.org.CODE_PPE_OGE }} <small class="badge badge-pill badge-info">ОГЭ</small></template>
          </b>
          <br>
          {{ stream.org.ADDRESS }}
          <br>
          <span>{{ stream.org.NAME_OO }}</span>
          <br>
          <span>ауд. {{ stream.room.CLASSROOM }}</span>
        </div>
        <archive :htmlId="'archive' + index" :from="from" :to="to" :id="stream.SYS_GUID"  @loaded="setLink($event)"></archive>
      </div>
      <div class="col-md-12">
        <form class="form py-4" @submit.prevent="save()">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="pos" class="text-white">Место нарушения</label>
              <input type="text" class="form-control bg-dark text-light" id="pos" v-model="entity.POSITION" />
            </div>
            <div class="col-md-4">
              <label for="date" class="text-white">Дата нарушения</label>
              <b-form-datepicker dark class="bg-dark text-light" id="date" v-bind="locale" v-model="date" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
            </div>
            <div class="col-md-4">
              <label for="time" class="text-white">Время нарушения</label>
              <b-form-timepicker class="bg-dark text-light" id="time" v-bind="locale" v-model="time" no-close-button></b-form-timepicker>
            </div>
          </div>
          <div class="form-group">
            <label for="type" class="text-white">Тип нарушения</label>
            <select class="form-control bg-dark text-light" id="type" v-model="entity.INFRINGEMENT_TYPE_FK">
              <option v-for="type in types" :value="type.SYS_GUID" :key="type.SYS_GUID">{{ type.NAME }}</option>
            </select>
          </div>
<!--          <div class="form-group">-->
<!--            <label for="type2" class="text-white">Выберите</label>-->
<!--            <select class="form-control bg-dark text-light" id="type2" v-model="entity.TYPE_INFRINGEMENT_OTHER">-->
<!--              <option v-for="type in others" :value="type.SYS_GUID" :key="type.SYS_GUID">{{ type.NAME }}</option>-->
<!--            </select>-->
<!--          </div>-->
          <div class="form-group">
            <label for="comment" class="text-white">Комментарий</label>
            <textarea class="form-control bg-dark text-light" id="comment" v-model="entity.COMMENT" rows="5"></textarea>
          </div>
          <div>
            <button type="submit" class="btn btn-primary">Отправить</button>
          </div>

        </form>
      </div>
    </div>

  </div>
</template>

<script>
  import Vuex from 'vuex'
  import Archive from '@/components/Archive'
  import moment from 'moment'
  import { apiQuery } from "../api";
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    name: "Violation",
    components: { Archive },
    props: {
      index: [Number, String]
    },
    data() {
      return {
        types: [],
        others: [],
        errors: [],
        linkLoaded: false,
        date: '',
        time: '',
        locale: {
            labelHours: 'Часов',
            labelMinutes: 'Минут',
            labelSeconds: 'Секунд',
            labelIncrement: 'Больше',
            labelDecrement: 'Меньше',
            labelSelected: 'Выбрано',
            labelNoTimeSelected: 'Время не выбрано',
            labelCloseButton: 'Закрыть',
            labelPrevDecade: 'Предыдущее десятилетие',
            labelPrevYear: 'Предыдущий год',
            labelPrevMonth: 'Предыдущий месяц',
            labelCurrentMonth: 'Текущий месяц',
            labelNextMonth: 'Следующий месяц',
            labelNextYear: 'Следующий год',
            labelNextDecade: 'Следующее десятилетие',
            labelToday: 'Сегодня',
            labelNoDateSelected: 'Дата не выбрана',
            labelCalendar: 'Календарь',
            labelNav: 'Навигация',
            labelHelp: ''
        },
        entity: {
          USER_FK: null,
          SCHOOL_FK: null,
          CAM_FK: this.$route.id,
          POSITION: null,
          DATE: null,
          INFRINGEMENT_TYPE_FK: null,
          INFRINGEMENT_OTHER: null,
          COMMENT: null,
          STATUS_INFRINGEMENT: 'sent',
          LINK_VIDEO: null
        }
      }
    },
    computed: {
      ...Vuex.mapGetters([
        'userInfo',
        'getStreams'
      ]),
      from() {
        return moment().subtract(5, 'minutes').format('DD.MM.YYYY HH:mm:ss')
      },
      to() {
        return moment().format('DD.MM.YYYY HH:mm:ss')
      },
      stream() {
        return this.getStreams[this.index]
      }
    },
    mounted() {
      apiQuery('private', 'data-get-records', {
        table: window.x2.tables.reasons
      }, false).then(res => {
        this.types = res.rows
      })
      // apiQuery('private', 'data-get-records', {
      //   table: window.x2.tables.otherreasons
      // }, false).then(res => {
      //   this.others = res.rows
      // })
      this.entity.USER_FK = this.userInfo.id
      this.entity.CAM_FK = this.stream.SYS_GUID
      this.date = moment().format('YYYY-MM-DD')
      this.time = moment().format('HH:mm')

      setTimeout(() => { this.sbppe = new PerfectScrollbar('#form') }, 100);

    },
    watch: {
      time() {
        this.entity.DATE = moment(this.date + ' ' + this.time).format('DD.MM.YYYY HH:mm:ss')
      },
      date() {
        this.entity.DATE = moment(this.date + ' ' + this.time).format('DD.MM.YYYY HH:mm:ss')
      },
      index() {
        this.$forceUpdate()
      }
    },
    methods: {
      save() {
        return apiQuery('private', 'data-create-record', {
          table: window.x2.tables.violations,
          record: {
            table: window.x2.tables.violations,
            data: this.entity
          }
        }, false).then(() => {
          this.$bvToast.toast('Данные сохранены', {
            title: 'Внимание',
            variant: 'success',
            solid: true
          })
          setTimeout(() => { this.$emit('submit'); }, 1000)
          // setTimeout(() => { this.$emit('submit'); }, 2000)
        }).catch(err => {
          this.errors = err
          this.$bvToast.toast(err.toString(), {
            title: 'Произошла ошибка',
            variant: 'danger',
            solid: true
          })
        })
      },
      setLink(link) {
        this.entity.LINK_VIDEO = link
        this.linkLoaded = true
      }
    }
  }
</script>

